import { restGet, restPost } from "apiCommandsExecutor/rest";

import {
    OrderDeliveryTypeDto,
    OrderDto,
    OrderPaymentTypeDto,
    OrdersPageDto,
    OrderStatusDto,
} from "./restModels";

export interface OrdersListFilter {
    menuId: number;
    // Границы периода — epoch millis, как их ждёт бэк.
    createdAfter: number;
    createdBefore: number;
    statuses: OrderStatusDto[];
    deliveryTypes: OrderDeliveryTypeDto[];
    paymentTypes: OrderPaymentTypeDto[];
    isPaid: boolean | null;
}

/*
* Заказы филиала (REST /api/rest/warehouse/v1). Заведение бэк берёт из аккаунта, меню — из
* параметра; выборка отсортирована от новых заказов к старым.
*
* Многозначные фильтры уходят одной строкой через запятую: пустой список означает «не
* ограничиваем», поэтому такие параметры в запрос не попадают вовсе.
* */
const listParam = (name: string, values: string[]) =>
    values.length === 0 ? {} : { [name]: values.join(",") };

export const getOrders = (filter: OrdersListFilter, skip: number, limit: number) =>
    restGet<OrdersPageDto>("/orders", {
        menuId: filter.menuId,
        createdAfter: filter.createdAfter,
        createdBefore: filter.createdBefore,
        skip,
        limit,
        ...listParam("statuses", filter.statuses),
        ...listParam("deliveryTypes", filter.deliveryTypes),
        ...listParam("paymentTypes", filter.paymentTypes),
        ...(filter.isPaid === null ? {} : { isPaid: filter.isPaid }),
    });

export const getOrder = (orderId: number) => restGet<OrderDto>(`/orders/${orderId}`);

export const refundOrderPayment = (orderId: number) =>
    restPost<OrderDto>(`/orders/${orderId}/payment-refund`);
